import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  height: 28px;
  border: 1px solid ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  border-radius: ${o => o.theme.borderRadius.sm};
  align-self: flex-end;
`

export const Button = styled.button`
  border: none;
  cursor: pointer;
  font-size: 13px;
  width: 28px;

  &[aria-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.4;
  }
`

export const Input = styled.input`
  border: none;
  color: inherit;
  font-weight: 600;
  text-align: center;
  width: 40px;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const SpinnerWrapper = styled.div`
  align-items: center;
  background: ${o => o.theme.color.deprecated.stoneLighter};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: ${o => o.theme.spacing(0, 0.5)};
  top: 0;
  width: 40px;
`
